import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=d0ef3870&"
import script from "./StaffView.vue?vue&type=script&lang=ts&"
export * from "./StaffView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports